<mat-card-header>
  <mat-card-title>{{ title }}</mat-card-title>
  @if (selectedRowsLength() > 0) {
    <mat-card-subtitle>
      {{ selectedRowsLength() }}
      @if (selectedRowsLength() === 1) {
        <language key="DatatableHeaderItemSelected" defaultValue="item selected"></language>
      } @else {
        <language
          key="DatatableHeaderMultipleItemSelected"
          defaultValue="items selected"
        ></language>
      }
    </mat-card-subtitle>
  }
  <nav class="header-actionbar">
    <ng-content select=".datatable-title-button"></ng-content>
    @if (!placeFilterInDatatableHeader) {
      <smd-filter
        [selectedSearchScope]="selectedSearchScope"
        (selectedSearchScopeChange)="selectedSearchScope = $event; refreshSearchScope()"
        [(filterValue)]="header.filterValue"
        (filterChange)="_onFilter()"
        [title]="title"
        [searchScopeConfigs]="searchScopeConfigs"
        [enableFilter]="header.enableFilter"
        [enableFilterbuilder]="header.enableFilterbuilder"
      ></smd-filter>
    }
    <button mat-icon-button class="close-icon" (click)="onCloseView.emit()">
      <mat-icon>close</mat-icon>
    </button>
  </nav>
</mat-card-header>
<mat-card-content>
  <mat-card appearance="raised" class="inner-card">
    <div class="smd-table-container">
      <div
        class="smd-data-table full-width"
        [class.disable-links]="disableLinks"
        [class.disable-row-click]="!headerRowIcon"
      >
        <div class="smd-data-table-scrollbuttons">
          <div #btnScrollLeft aria-hidden="true" class="scroll-left mat-ripple" md-ripple="">
            <div class="chevron"></div>
          </div>
          <div #btnScrollRight aria-hidden="true" class="scroll-right mat-ripple" md-ripple="">
            <div class="chevron"></div>
          </div>
        </div>
        <div class="smd-data-table-header">
          <ng-content select="smd-datatable-header"></ng-content>
        </div>
        <div #scrollPane class="smd-data-table-scrollpane">
          <table>
            <thead>
              <tr class="smd-datatable-normal-header">
                @if (_shouldRenderCheckbox() && isSelectionModeMultiple) {
                  <th class="smd-datatable-header-checkbox">
                    <mat-checkbox [(ngModel)]="checked" (change)="_onMasterCheckChange()">
                    </mat-checkbox>
                  </th>
                }
                @if (_shouldRenderCheckbox() && isSelectionModeSingle) {
                  <th></th>
                }
                @if (headerRowIcon) {
                  <th class="smd-row-icon {{ headerRowIcon.styleClass }}">
                    @if (headerRowIcon.icon) {
                      <button
                        mat-icon-button
                        (click)="_onRowIconClick(null)"
                        [matTooltip]="headerRowIconTooltip"
                      >
                        <mat-icon>{{ headerRowIcon.icon }}</mat-icon>
                      </button>
                    }
                  </th>
                }
                @for (column of columns; track column) {
                  <th
                    [class.smd-datatable-column-sortable]="column.sortable"
                    [class.smd-numeric-column]="column.numeric"
                    (click)="_sortColumn(column)"
                  >
                    <span
                      matTooltip="{{ column.titleTooltip }}"
                      [class.smd-sorted-asc]="column.sortDir == 'asc'"
                      [class.smd-sorted-desc]="column.sortDir == 'desc'"
                    >
                      {{ column.title }}
                    </span>
                  </th>
                }
              </tr>
              @if (responsive && (_shouldRenderCheckbox() || headerRowIcon)) {
                <tr class="smd-datatable-responsive-header">
                  @if (_shouldRenderCheckbox() && isSelectionModeMultiple) {
                    <th [attr.colspan]="columns.length + 1">
                      <mat-checkbox [(ngModel)]="checked" (change)="_onMasterCheckChange()">
                      </mat-checkbox>
                    </th>
                  }
                  @if (_shouldRenderCheckbox() && isSelectionModeSingle) {
                    <th [attr.colspan]="columns.length + 1"></th>
                  }
                  @if (headerRowIcon) {
                    <th class="smd-row-icon {{ headerRowIcon.styleClass }}">
                      <button mat-icon-button (click)="_onRowIconClick(null)">
                        <mat-icon>{{ headerRowIcon.icon }}</mat-icon>
                      </button>
                    </th>
                  }
                </tr>
              }
            </thead>
            @if (rows?.length > 0) {
              <tbody>
                @for (row of visibleRows; track row) {
                  <tr
                    #dataTableRow
                    smd-datatable-row
                    [class.is-selected]="row.checked"
                    [row]="row"
                    [renderCheckbox]="_shouldRenderCheckbox()"
                    [columns]="columns"
                  ></tr>
                }
              </tbody>
            }
          </table>
          @if (loading) {
            <div class="loader">
              <mat-progress-spinner mode="indeterminate"></mat-progress-spinner>
            </div>
          }
          @if (!loading && rows.length == 0) {
            <div>
              @if (emptyResultText == null || emptyResultText.length == 0) {
                <span>
                  <language key="EmptyList" defaultValue="No items."></language>
                </span>
              }
              @if (emptyResultText != null && emptyResultText.length > 0) {
                <span>{{ emptyResultText }}</span>
              }
            </div>
          }
        </div>
      </div>
    </div>
  </mat-card>
</mat-card-content>
<mat-card-footer>
  <div class="smd-data-table-footer" [hidden]="!paginated || loading || rows.length == 0">
    <!-- Using hidden because *ngIf is conflicting with ViewChild(SmdPaginatorComponent) -->
    <div class="footer-left">
      <language key="DatatableTotalItems" defaultValue="Total items:"></language>
      {{ formatNumber(displayedTotalCount) | async }}<br />
      @if (loadTimestamp) {
        <span>
          <language key="DatatableTimeLoaded" defaultValue="Data loaded at"></language>
          {{ loadTimestamp | localDate: 'LTS' | async }}
        </span>
      }
      <br />
      @if (showLoadingTime && loadingTime != null) {
        <span>
          <language key="DatatableLoadingTime" defaultValue="Loading Time:"></language>
          {{ loadingTime }} ms
        </span>
      }
    </div>
    <smd-paginator (pageChange)="_onPageChange($event)"></smd-paginator>
  </div>
</mat-card-footer>
